import script from "./Statement.vue?vue&type=script&setup=true&lang=js"
export * from "./Statement.vue?vue&type=script&setup=true&lang=js"

import "./Statement.vue?vue&type=style&index=0&id=37fa84bd&lang=css"

const __exports__ = script;

export default __exports__